<template>
  <b-row >
    <b-col lg="3" sm="6" md="6" cols="6" v-if="admin" align="center">
      <el-checkbox  v-model="VisualEmpresa.regla" label="Regla" border></el-checkbox>
    </b-col>
    <b-col lg="3" sm="6" md="6" cols="6" align="center">
      <el-checkbox  v-model="VisualEmpresa.fecha_fab" label="Fabricante/Fecha FDS" border></el-checkbox>
    </b-col>
    <!-- <b-col lg="3" sm="6" md="6" v-if="admin">
      <label class="mr-sm-2" for="inline-form-custom-select-pref">Empresa</label>

      <b-form-select v-model="VisualEmpresa.empresa" :options="optempresas" size="sm" class="form-control" />
    </b-col> -->
  </b-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "productos-etiquetas-vista-adm",
  data() {
    return {
      admin: true
    };
  },
  computed: {
    ...mapState('etiquetas',[
        'idiomas',
        'VisualEmpresa'
    ])
  },
};
</script>
